import { type FC, useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus'
import { P3 } from '../../../compass-ui'
import type { AccordionTabProps } from '../Accordion.types'

const AccordionTab: FC<AccordionTabProps> = ({ id, title, content, contentParagraphBreak }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const [contentHeight, setContentHeight] = useState<string>('0px')

  const contentRef = useRef<HTMLDivElement>(null)

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded)
    setContentHeight(isExpanded ? '0px' : `${contentRef?.current?.scrollHeight}px`)
  }

  return (
    <div className="border-b-[1px] grid col-span-full">
      <div
        className="flex h-20 place-content-between items-center text-blue-600"
        role="button"
        aria-controls={id}
        aria-expanded={isExpanded}
        onClick={toggleAccordion}
        onKeyDown={toggleAccordion}
        tabIndex={0}
      >
        <P3 color={isExpanded ? 'text-blue-600' : 'text-ink-800'}>
          <span className="font-semibold">{title}</span>
        </P3>
        <FontAwesomeIcon
          icon={isExpanded ? faMinus : faPlus}
          className="text-blue-600"
          id="expand-collapse-icon"
          data-testid="expand-collapse-icon"
        />
      </div>

      <div
        id={id}
        className="h-0 overflow-scroll ease-in duration-150"
        ref={contentRef}
        style={{ height: `${contentHeight}` }}
      >
        <div className="pb-6">
          {typeof content === 'string' ? (
            <>
              <P3>{content}</P3>
              {contentParagraphBreak && (
                <div className="mt-5">
                  <P3>{contentParagraphBreak}</P3>
                </div>
              )}
            </>
          ) : (
            content
          )}
        </div>
      </div>
    </div>
  )
}

export default AccordionTab
